import React, { createContext, Dispatch, SetStateAction, useState } from 'react';
import { MandatoryChildren } from '../models/children-props';

export type PostScheduleProviderProps = MandatoryChildren & {
  // ...
};

type InstagramGridValueType = {
  loadingPage: boolean;
  setLoadingPage: React.Dispatch<React.SetStateAction<boolean>>;
  loadingPosts: boolean;
  setLoadingPosts: Dispatch<SetStateAction<boolean>>;
  selectedProfileId: string;
  setSelectedProfileId: Dispatch<SetStateAction<string>>;
  sliderValue: number | undefined;
  setSliderValue: Dispatch<SetStateAction<number | undefined>>;
};

export const InstagramGridContext = createContext<InstagramGridValueType>({
  loadingPage: false,
  setLoadingPage: () => {
    // ...
  },
  loadingPosts: false,
  setLoadingPosts: () => {
    // ...
  },
  selectedProfileId: '',
  setSelectedProfileId: () => {
    // ...
  },
  sliderValue: undefined,
  setSliderValue: () => {
    // ...
  }
});

export const InstagramGridProvider = (props: PostScheduleProviderProps): JSX.Element => {
  const { children } = props;
  const [selectedProfileId, setSelectedProfileId] = useState<string>('');
  const [sliderValue, setSliderValue] = useState<number | undefined>(undefined);
  const [loadingPage, setLoadingPage] = useState<boolean>(true);
  const [loadingPosts, setLoadingPosts] = useState<boolean>(true);

  return (
    <InstagramGridContext.Provider
      value={{
        loadingPage,
        setLoadingPage,
        loadingPosts,
        setLoadingPosts,
        selectedProfileId,
        setSelectedProfileId,
        sliderValue,
        setSliderValue
      }}>
      {children}
    </InstagramGridContext.Provider>
  );
};
